export var ValuationBlockStructureTypeHeadingEnum;
(function (ValuationBlockStructureTypeHeadingEnum) {
    ValuationBlockStructureTypeHeadingEnum["StructureType"] = "Structure type";
    ValuationBlockStructureTypeHeadingEnum["AdjustmentFactor"] = "Adjustment factor";
})(ValuationBlockStructureTypeHeadingEnum || (ValuationBlockStructureTypeHeadingEnum = {}));
export const ValuationBlockStructureTypeConfigHeadingLookup = new Map([[ValuationBlockStructureTypeHeadingEnum.StructureType, "structureType"], [ValuationBlockStructureTypeHeadingEnum.AdjustmentFactor, "adjustmentFactor"]]);
